import * as React from "react";
import { useFilters } from "../utils";

const toCategoryMap = (categories) =>
  Object.fromEntries(
    categories.map((cat) => [
      cat.id,
      {
        id: cat.id,
        name: cat.label,
        subcategories: cat.children.map((child) => ({
          id: child.id,
          name: child.label,
        })),
      },
    ]),
  );

export default function useCategoryMap() {
  const { filters } = useFilters();

  return React.useMemo(
    () => toCategoryMap(filters.categories),
    [filters.categories],
  );
}
